// NOMBASE - Icon registry
// Lucide icons are React components and can't be JSON-serialised into
// localStorage. We store the icon's NAME (e.g. 'Building2') and resolve
// the component at render time. Falls back to `Circle` if the name is
// unknown so the sidebar never breaks on a stale cache entry.
import * as Lucide from 'lucide-react';
import DriveIcon from '@/components/icons/DriveIcon';

// Custom (non-Lucide) icons we want addressable via the same name-based
// lookup as sidebar / launcher tiles.
const CUSTOM = {
  Drive: DriveIcon,
};

export const getIcon = (name) => CUSTOM[name] || Lucide[name] || Lucide.Circle;

export default getIcon;
